<template>
  <div class="grid">
    <DevelopersItem
      v-for="developer in data"
      :key="developer.id"
      :data="developer"
    />
  </div>
</template>

<script>
import DevelopersItem from "./developers/Item.vue";

export default {
  components: {
    DevelopersItem
  },
  props: {
    data: {
      type: Array
    }
  }
};
</script>
